import { render, staticRenderFns } from "./ProcessInputEvents.vue?vue&type=template&id=327bfc7d&scoped=true"
import script from "./ProcessInputEvents.vue?vue&type=script&lang=js"
export * from "./ProcessInputEvents.vue?vue&type=script&lang=js"
import style0 from "./ProcessInputEvents.vue?vue&type=style&index=0&id=327bfc7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327bfc7d",
  null
  
)

export default component.exports